import React, { useEffect, useState } from "react";
import LeftIcon from "../../images/LeftIcon";
import ArrowRightIcon from "../../images/ArrowRightIcon";
import DraftIcon from "../../images/DraftIcon";
import SaveIcon from "../../images/SaveIcon";
import {
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
} from "../../services/navigate.service";
import {
  createGroupTax,
  getDetailGroupTax,
  updateGroupTax,
} from "../../services/tax.services";
import PopupLocation from "../../components/PopupLocation";
import { showToast } from "../../services/toast.service";
import { showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import BackIcon from "../../images/BackIcon";
import { useResponsive } from "../../hook/useResponsive";
import { useFormKeyboard } from "../../hook/useFormKeyboard";

interface TermsResponse {
  groupName: string;
  groupCode: string;
}

const CreateGroupTax: React.FC = () => {
  const preLanguage = localStorage.getItem("language");
  const [formValues, setFormValues] = useState<TermsResponse>({
    groupName: "",
    groupCode: "",
  });
  const { isMobile, getWidth } = useResponsive();
  const [errors, setErrors] = useState<any>({});
  const limits = useFieldLimits(coreFormLimits("tax-group"));
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const path = window.location.pathname;
  const id: string = path.split("/").pop() || "";
  const [language, setLanguage] = useState<any>(null);
  const kb = useFormKeyboard({ autoFocus: id === "new" && !isMobile });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (id !== "new") {
      fetchData(id);
    }
    const handleNewToken = () => {
      if (id !== "new") {
        fetchData(id);
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [path]);
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  const fetchData = async (id: string) => {
    webLoadingTrue();
    try {
      const response: any = await getDetailGroupTax(id);
      console.log("🚀 ~ fetchData ~ response:", response);
      setFormValues(response.data);
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      webLoadingFalse();
    }
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits({ ...formValues }, limits, language);
    if (!formValues.groupName) {
      newErrors.groupName = "Group TAX Name is required";
    }
    if (!formValues.groupCode) {
      newErrors.groupCode = "Group TAX Code is required";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    webLoadingTrue();
    if (id === "new") {
      try {
        const response: any = await createGroupTax(formValues);
        if (response?.data?.id) {
          webNavigate("/" + preLanguage + "/tax");
          webLoadingFalse();
          showToast({
            message: "Group Tax Created !",
            type: "success",
            duration: 20000,
          });
        }
      } catch (error: any) {
        webLoadingFalse();

        showApiError(error, { language, setFieldErrors: setErrors });
      }
    } else {
      try {
        const response: any = await updateGroupTax(id, formValues);
        if (response?.data?.id) {
          webNavigate("/" + preLanguage + "/tax");
          webLoadingFalse();
          showToast({
            message: "Group Tax Updated !",
            type: "success",
            duration: 20000,
          });
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, { language, setFieldErrors: setErrors });
      }
    }
  };

  return (
    <div {...kb.scopeProps}>
      <div className="bg-white">
        <div className="flex items-center ">
          <button
            type="button"
            aria-label={language?.["Back"] ?? "Back"}
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate("/" + preLanguage + "/companies" + "?tab=group");
            }}
          >
            <BackIcon />
          </button>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Back"] ? language?.["Back"] : "Back"}
          </p>
        </div>
      </div>
      {id === "new" ? (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.[`Add TAX Group`]
            ? language?.[`Add TAX Group`]
            : `Add TAX Group`}
        </p>
      ) : (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.[`Edit TAX Group`]
            ? language?.[`Edit TAX Group`]
            : `Edit TAX Group`}
        </p>
      )}
      <form onSubmit={handleSubmit} style={{ height: isMobile ? "auto" : "calc(100% - 163px)" }}>
        <div
          className="rounded-md bg-white flex items-start "
          style={{ gap: "24px" }}
        >
          <div style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
            <div className="space-y-2">
              <div className="flex items-center">
                <p
                  className="text-[14px] font-inter leading-[20px] font-medium"
                  style={{ color: "#4A5353" }}
                >
                  {language && language?.["Group TAX code"]
                    ? language?.["Group TAX code"]
                    : "Group TAX code"}
                </p>
                <p
                  className="text-[14px] font-inter leading-[20px]"
                  style={{ color: "#BA0E13" }}
                >
                  {language && language?.["*"] ? language?.["*"] : "*"}
                </p>
              </div>
              <div className="w-full">
                <input
                  required
                  type="text"
                  name="groupCode"
                  {...limitProps(limits, "groupCode")}
                  value={formValues.groupCode} // Use groupCode instead of formValues?.groupCode
                  onChange={handleChange}
                  className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-transparent w-full"
                />
                <FieldCounter value={formValues.groupCode} max={limits.groupCode?.maxLength} />
              </div>
              {errors.groupCode && <p className="error">{errors.groupCode}</p>}
            </div>
          </div>
          <div style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
            <div className="space-y-2">
              <div className="flex items-center">
                <p
                  className="text-[14px] font-inter leading-[20px] font-medium"
                  style={{ color: "#4A5353" }}
                >
                  {language && language?.["Group TAX name"]
                    ? language?.["Group TAX name"]
                    : "Group TAX name"}
                </p>
                <p
                  className="text-[14px] font-inter leading-[20px]"
                  style={{ color: "#BA0E13" }}
                >
                  {language && language?.["*"] ? language?.["*"] : "*"}
                </p>
              </div>
              <div className="w-full">
                <input
                  required
                  type="text"
                  name="groupName"
                  {...limitProps(limits, "groupName")}
                  value={formValues.groupName} // Use groupName instead of formValues?.groupName
                  onChange={handleChange}
                  className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-transparent w-full"
                />
                <FieldCounter value={formValues.groupName} max={limits.groupName?.maxLength} />
              </div>
              {errors.groupName && <p className="error">{errors.groupName}</p>}
            </div>
          </div>
        </div>
      </form>
      <div
        className="w-full flex items-center justify-end"
        style={{ marginTop: "24px", gap: "12px" }}
      >
        <button
          type="button"
          onClick={() => {
            webNavigate("/" + preLanguage + "/companies" + "?tab=group");
          }}
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#222525",
            fontSize: "14px",
            fontWeight: "500",
            border: "1px solid #C9D7D8",
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.["Cancel"] ? language?.["Cancel"] : "Cancel"}
        </button>
        <button
          type="button"
          {...kb.primaryProps(handleSubmit)}
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#FFFFFF",
            fontSize: "14px",
            fontWeight: "500",
            backgroundColor: "#0F7679",
          }}
          className="font-inter cursor-pointer"
        >
          <p className="text-[14px] leading-[22px] font-inter">
            {language && language?.["Save"] ? language?.["Save"] : "Save"}
          </p>
        </button>
      </div>
      <PopupLocation
        show={showPopup}
        title={`${id === "new"
          ? language && language?.["Create Group Tax"]
            ? language?.["Create Group Tax"]
            : "Create Group Tax"
          : language && language?.["Update Group Tax"]
            ? language?.["Update Group Tax"]
            : "Update Group Tax"
          }`}
        desc={`${id === "new"
          ? language && language?.["Create Group Tax Failed"]
            ? language?.["Create Group Tax Failed"]
            : "Create Group Tax Failed"
          : language && language?.["Update Group Tax Failed"]
            ? language?.["Update Group Tax Failed"]
            : "Update Group Tax Failed"
          }`}
        onClose={handleClosePopup}
        onOpen={handleOpenPopup}
      />
    </div>
  );
};

export default CreateGroupTax;
